import { Country } from '@tiendanube/common/src/enums';

export const getTiendanubeUrl = (country: Country) => {
  const stg = `https://www.nubestaging.com${country === 'BR' ? '.br' : ''}`;
  const prod =
    country === 'BR'
      ? 'https://www.nuvemshop.com.br'
      : 'https://www.tiendanube.com';

  return ['production', 'test'].includes(process.env.NODE_ENV || '')
    ? prod
    : stg;
};
